/**
 * Compare Split Panel
 * Drag handle to resize left/right columns on the compare page.
 * Persists split ratio in sessionStorage.
 */
var CompareSplit = (function() {
  'use strict';

  var panel = null;

  function getContainer() {
    return document.querySelector('[data-compare-split]');
  }

  function getLeft() {
    var c = getContainer();
    return c ? c.querySelector('[data-compare-split-left]') : null;
  }

  function getRight() {
    var c = getContainer();
    return c ? c.querySelector('[data-compare-split-right]') : null;
  }

  function getHandle() {
    var c = getContainer();
    return c ? c.querySelector('[data-compare-split-handle]') : null;
  }

  function buildPanel() {
    if (!window.SplitPanel) return null;
    return new window.SplitPanel({
      minWidth: 320,
      storageKey: 'compareSplitRatio',
      getContainer: getContainer,
      getLeft: getLeft,
      getRight: getRight,
      getHandle: getHandle,
      collapseBelowMin: true
    });
  }

  function init() {
    if (panel) return;
    panel = buildPanel();
    if (panel) {
      panel.init();
      window.CompareSplitPanel = panel;
    }
  }

  function reset() {
    if (panel) {
      panel.reset();
      panel = null;
    }
    window.CompareSplitPanel = null;
  }

  return { init: init, reset: reset };
})();

document.addEventListener('turbolinks:load', function() {
  CompareSplit.reset();
  CompareSplit.init();
});
document.addEventListener('turbo:load', function() {
  CompareSplit.reset();
  CompareSplit.init();
});

if (document.readyState !== 'loading' && document.querySelector('[data-compare-split]')) {
  CompareSplit.init();
}

window.CompareSplit = CompareSplit;
